import axios from 'axios';

const $axios = axios.create({
    baseURL: 'https://nasmoco.net/online_booking/',
    //baseURL: 'https://trialit2.nasmoco.co.id/pwa/api/v1/',
    // baseURL: 'http://localhost/api-nasmoco-master/',
    // baseURL: 'https://api.ufotostudio.com/v1/',
    headers: {
        'Content-Type': 'application/json',
        'x-api-key': process.env.VUE_APP_NASMOCO_NET_API_KEY
    }
});

export default $axios;